export default __webpack_public_path__ + "static/media/linkein-hero.0200a548.svg";